import React, { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import api from "../../../services/api";
import FlavorFormModal from "./FlavorFormSections/FlavorFormModal";
import FlavorsTable from "./FlavorsTable";
import FlavorDetailDrawer from "./FlavorFormSections/FlavorDetailDrawer";

const Flavors = () => {
  const [flavors, setFlavors] = useState([]);
  const [selectedFlavor, setSelectedFlavor] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    fetchFlavors();
  }, []);

  const fetchFlavors = async () => {
    try {
      const response = await api.get("/flavors");
      setFlavors(response.data);
    } catch (error) {
      console.error("Error fetching flavors:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/flavors/${id}`);
      setFlavors((prevFlavors) =>
        prevFlavors.filter((flavor) => flavor._id !== id)
      );
    } catch (error) {
      console.error("Error deleting flavor:", error);
    }
  };

  return (
    <Box sx={{ padding: "1rem" }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Manage Flavors
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setIsModalOpen(true)}
        sx={{ mb: 2 }}>
        Add Flavor
      </Button>
      <FlavorsTable
        data={flavors}
        onEdit={(flavor) => {
          setSelectedFlavor(flavor);
          setIsModalOpen(true);
        }}
        onDelete={handleDelete}
        onMoreInfo={(flavor) => {
          setSelectedFlavor(flavor);
          setDrawerOpen(true);
        }}
      />
      {isModalOpen && (
        <FlavorFormModal
          onClose={() => {
            setIsModalOpen(false);
            setSelectedFlavor(null);
          }}
          onSave={fetchFlavors}
          flavor={selectedFlavor}
        />
      )}

      <FlavorDetailDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        flavor={selectedFlavor}
      />
    </Box>
  );
};

export default Flavors;
